// List of routes/paths used across the platform

const account = "/account";
const company = "/company";
const settings = "/settings";
const vault = "/vault";
const notifications = "/notifications";
const reseller = "/reseller";
const financing = "/financing";
const treasury = "/treasury";
const onboarding = "/onboarding";
const onboardingAlt = "/request";
const design = "/design";

const routes = {
  Test: "/test",
  // External links
  EmailSupport: "support@leano.fr",
  EmailInfo: "info@leano.fr",
  TermsOfService: "https://leano.fr/condition-generales-utilisation/",
  PrivacyPolicy: "https://leano.fr/politique-de-confidentialite/",
  // Error page
  Error500: "/error",
  // Home pages
  Home: "/",
  Redirect: "redirect",
  Onboarding: {
    root: onboarding,
    alt: onboardingAlt,
  },
  Account: {
    root: account,
    SignUp: account + "/sign-up",
    SignUpInvite: account + "/sign-up/invitation",
    SignUpDirect: account + "/sign-up/direct",
    EmailConfirmation: account + "/confirm",
    Login: account + "/sign-in",
    Logout: account + "/sign-out",
    PasswordReset: account + "/password/reset",
    PasswordResetCodeOK: account + "/password/reset/confirm",
    Inactive: account + "/inactive",
  },
  Company: {
    root: company,
    reps: company + "/representants",
  },
  Settings: {
    root: settings,
    profile: settings + "/profile",
    password: settings + "/password",
    users: settings + "/users",
    company: settings + "/company",
    subscription: settings + "/subscription",
    theme: settings + "/theme",
  },
  Notifications: {
    root: notifications,
  },
  Vault: {
    root: vault,
    bank: vault + "/banking",
    finance: vault + "/statements",
    id: vault + "/identity",
    other: vault + "/documents",
  },
  VaultAllow: "/allow-vault",
  Reseller: {
    root: reseller,
    clients: reseller + "/clients",
  },
  Financing: {
    root: financing,
    assess: financing + "/dashboard",
    unlock: financing + "/use-cases",
    request: financing + "/request",
    loans: financing + "/loans",
  },
  Treasury: {
    root: treasury,
    graph: treasury + "/graph",
    debt: treasury + "/debt",
    alerts: treasury + "/alerts",
    partners: treasury + "/partners",
  },
  Design: {
    root: design,
  },
};

export default routes;

export const dashboardRoute = routes.Financing.assess;

export const getRelativePath = (absolutePath) =>
  absolutePath.split("/")[absolutePath.split("/").length - 1];
